/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_TitleInputs */

const es_home_hero_title = /** @type {(inputs: Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu conocimiento empresarial, una pregunta de distancia`)
};

const en_home_hero_title = /** @type {(inputs: Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your enterprise knowledge, one question away`)
};

/**
* | output |
* | --- |
* | "Your enterprise knowledge, one question away" |
*
* @param {Home_Hero_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_title = /** @type {((inputs?: Home_Hero_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_title(inputs)
	return en_home_hero_title(inputs)
});
export { home_hero_title as "home.hero.title" }